/** Scripts pour le Menu des Catégories de Produits */

import { A } from "@mobily/ts-belt";
import { match } from "ts-pattern";

import { SELECTEUR_ENTREE_MENU_CATEGORIES_PRODUITS, SELECTEUR_MENU_CATEGORIES_PRODUITS } from "./constantes/dom.ts";
import { recupereEleOuLeve, recupereElesOuLeve } from "./lib/utils.ts";

document.addEventListener("DOMContentLoaded", (): void => {
  const MENU_CATEGORIES_PRODUITS: HTMLElement = recupereEleOuLeve(SELECTEUR_MENU_CATEGORIES_PRODUITS);
  const ENTREES_MENU_CATEGORIES_PRODUITS: Array<HTMLAnchorElement> = recupereElesOuLeve(
    SELECTEUR_ENTREE_MENU_CATEGORIES_PRODUITS,
  );

  A.forEachWithIndex(
    [ENTREES_MENU_CATEGORIES_PRODUITS.at(0), ENTREES_MENU_CATEGORIES_PRODUITS.at(-1)],
    (index, entreeMenu) => {
      if (!entreeMenu) return;

      new IntersectionObserver(
        A.forEach(entree => {
          // Ne déclenche rien si le scroll n'est pas horizontal
          if (entree.boundingClientRect.top <= 0) return;
          match([entree.isIntersecting, index])
            .with([true, 0], () => MENU_CATEGORIES_PRODUITS.removeAttribute("data-entrees-presentes-debut"))
            .with([true, 1], () => MENU_CATEGORIES_PRODUITS.removeAttribute("data-entrees-presentes-fin"))
            .with([false, 0], () => MENU_CATEGORIES_PRODUITS.setAttribute("data-entrees-presentes-debut", ""))
            .with([false, 1], () => MENU_CATEGORIES_PRODUITS.setAttribute("data-entrees-presentes-fin", ""))
            .run();
        }),
        { root: null, threshold: 0.9 },
      ).observe(entreeMenu);
    },
  );
});
